import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from "@headlessui/react";
import { CheckCircleIcon, CheckIcon, ChevronUpDownIcon, HomeIcon } from "@heroicons/react/24/solid";
import { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import useLoading from "../../../hooks/useLoading";
import useAuth from "../../../hooks/useAuth";
import { nonAuthInstance } from "../../../services/axiosConfig";
import { getAdminDetails, getAdminLevelCds } from "../../../services/ api_services";
import { isArray, isEmpty } from "lodash";
import useToast from "../../../hooks/useToast";
import { ToastTypes } from "../../../context/ToastProvider";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import ResetPassDialog from "../../../components/dialogs/ResetPassDialog";
import SelectMenu from "../../../components/SelectMenu";
import SearchOrgDialog from "../../../components/dialogs/SearchOrgDialog";

const pages = [
    { name: "관리자 관리", href: "/ad/admin", current: false },
    { name: "상세보기", href: "", current: true },
];

const checkOptions = [
    { name: "선택", value: null },
    { name: "사용", value: "0001" },
    { name: "탈퇴", value: "0002" },
    { name: "신규가입", value: "0003" },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function AdminInfo() {
    const { auth } = useAuth();
    const { adminSeq } = useParams();
    const { loading, setLoading } = useLoading();
    const { showToast } = useToast();

    let cancelconds;

    const AdminDetailCond = {
        adminSeq: "",
        adminId: "",
        adminPw: "",
        adminHpNo: "",
        adminNm: "",
        adminEmail: "",
        adminType: "",
        adminAddr1: "",
        adminAddr2: "",
        adminLevelCd: "",
        adminSalt: "",
        adminReg: "",
        adminRegConvert: "",
        adminLevelNm: "",
        orgId: null,
    };

    const [cond, setCond] = useState(AdminDetailCond);
    const [selectedAdminLevelCd, setSelectedAdminLevelCd] = useState(null);
    const [listAdminLevelCd, setListAdminLevelCd] = useState([]);
    const [checked, setChecked] = useState(checkOptions[0]);

    const [showResetPassDialog, setShowResetPassDialog] = useState(false);
    const [showOrgPopup, setShowOrgPopup] = useState(false);
    
    const location = useLocation();
    const [orgTree, setOrgTree] = useState([]);

    useEffect(() => {
        if (location.state?.orgtree && location.state.orgtree.length > 0) {
            setOrgTree(location.state.orgtree);
        }
    }, [location.state]);

    useEffect(() => {
        selectAdminLevelCd();
        selectAdminDetail();
    }, []);

    const selectAdminLevelCd = async () => {
        const response = await getAdminLevelCds();
        console.log("🚀 ~ selectAdminLevelCd ~ response:", response);
        if (response && !isEmpty(response.data) && isArray(response.data)) {
            let listTmp = [];
            response.data.map((item) => {
                listTmp.push({
                    code: item.spec_code,
                    name: item.spec_nm,
                });
            });
            console.log("🚀 ~ selectAdminLevelCd ~ listTmp:", listTmp);
            setListAdminLevelCd(listTmp);
            setSelectedAdminLevelCd(listTmp[0]);
        } else {
            setListAdminLevelCd([]);
        }
    };

    /**
     * 상세정보 조회 (selectAdminDetail)
     * @returns
     */
    const selectAdminDetail = async () => {
        setLoading(true);
        console.log("adminSeq", adminSeq);
        try {
            const { data, cancel, error } = await getAdminDetails(adminSeq);
            cancelconds = cancel;
            if (data) {
                console.log("selectAdminDetail of res ==>", data);
                if (!isEmpty(data)) {
                    const adminInfo = data[0].admin_info;
                    console.log("AdminInfo ==> ", adminInfo);

                    setCond((prevValue) => {
                        return {
                            ...prevValue,
                            adminSeq: adminInfo.admin_seq,
                            adminId: adminInfo.admin_id,
                            adminPw: adminInfo.admin_pw,
                            adminHpNo: adminInfo.admin_hp_no,
                            adminNm: adminInfo.admin_nm,
                            adminEmail: adminInfo.admin_email,
                            adminType: adminInfo.admin_type,
                            adminAddr1: adminInfo.admin_addr1,
                            adminAddr2: adminInfo.admin_addr2,
                            adminLevelCd: adminInfo.admin_level_cd,
                            adminSalt: adminInfo.admin_salt,
                            adminReg: adminInfo.admin_reg,
                            adminLevelNm: data[0].admin_level_nm,
                            orgId: adminInfo.org_id,
                        };
                    });
                    setChecked(
                        checkOptions.find((opt) => opt.value === adminInfo.admin_type) || checkOptions[0]
                    );

                    var sYear = adminInfo.admin_reg.substring(0, 4);
                    var sMonth = adminInfo.admin_reg.substring(5, 7);
                    var sDate = adminInfo.admin_reg.substring(8, 10);

                    // console.log("sYear", sYear);
                    // console.log("sMonth", sMonth);
                    // console.log("sDate", sDate);

                    setCond((prevValue) => {
                        return {
                            ...prevValue,
                            adminRegConvert: sYear + "-" + sMonth + "-" + sDate,
                        };
                    });
                } else {
                    setCond(AdminDetailCond);
                    showToast(ToastTypes.ERROR, "오류", "데이터를 불러오는 중 문제가 발생했습니다.잠시 후 다시 시도해 주세요.");
                }
            } else if (error) {
                setCond(AdminDetailCond);
                showToast(ToastTypes.ERROR, "오류", error);
                console.log("Error ==> ", error);
            }

            setLoading(false);
        } catch (e) {
            console.log("e ==>", e);
            setCond(AdminDetailCond);
            showToast(ToastTypes.ERROR, "오류", e);
            setLoading(false);
        }
    };

    useEffect(() => {
        // console.log("ADMIN LEVEL CD ==> ", cond.adminLevelCd);
        if (listAdminLevelCd && !isEmpty(listAdminLevelCd) && isArray(listAdminLevelCd)) {
            setSelectedAdminLevelCd(listAdminLevelCd.find((item) => item.code === cond.adminLevelCd));
        }
    }, [cond.adminLevelCd]);

    /**
     * 상세정보 업데이트 (updateAdminInfo)
     * @returns
     */
    function updateAdminInfo() {
        let condTmp = {
            admin_seq: cond.adminSeq,
            admin_id: cond.adminId,
            admin_hp_no: cond.adminHpNo,
            admin_nm: cond.adminNm,
            admin_email: cond.adminEmail,
            admin_type: cond.adminType,
            admin_addr1: cond.adminAddr1,
            admin_addr2: cond.adminAddr2,
            admin_level_cd: cond.adminLevelCd,
            org_id : cond.orgId,
        };

        console.log("updateAdminInfo of condTmp ==>", condTmp);
        updateAdminDetail(condTmp);
    }

    /**
     * 상세정보 업데이트 API
     * @returns
     */
    const updateAdminDetail = async (inputCond) => {
        setLoading(true);
        console.log("updateAdminDetail of inputCond ==>", inputCond);
        try {
            const response = await nonAuthInstance.post("/admin/update/detail", inputCond);
            console.log("updateAdminDetail of response==>", response);
            showToast(ToastTypes.SUCCESS, "성공", "업데이트 완료 하였습니다.");
            selectAdminDetail();
            setLoading(false);
        } catch (e) {
            console.log("e ==>", e);
            setLoading(false);
        }
    };

    return (
        <div>
            <nav className="flex border-b border-gray-200 bg-white -mx-8 -mt-6 max-w-full" aria-label="Breadcrumb">
                <ol className=" flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8">
                    <li className="flex">
                        <div className="flex items-center">
                            <a href="/" className="text-gray-400 hover:text-gray-500">
                                <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                                <span className="sr-only">Home</span>
                            </a>
                        </div>
                    </li>
                    {pages.map((page) => (
                        <li key={page.name} className="flex">
                            <div className="flex items-center">
                                <svg
                                    className="h-full w-6 flex-shrink-0 text-gray-200"
                                    viewBox="0 0 24 44"
                                    preserveAspectRatio="none"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                                </svg>
                                <Link
                                    to={page.href}
                                    className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                    aria-current={page.current ? "page" : undefined}
                                >
                                    {page.name}
                                </Link>
                            </div>
                        </li>
                    ))}
                </ol>
            </nav>
            <ResetPassDialog
                userSeq={cond.adminSeq}
                isOpen={showResetPassDialog}
                onClose={() => setShowResetPassDialog(false)}
                isAdmin={true}
            />
            {/* <ResetPasswordDialog userSeq={cond.adminSeq} isOpen={showResetPassDialog} onClose={() => setShowResetPassDialog(false)} /> */}
            <div className="isolate bg-white px-6 py-24 sm:py-10 lg:px-8 max-w-full">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mt-10">상세보기</h2>
                </div>
                <div className="mx-auto max-w-xl sm:mt-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                        <div>
                            <label htmlFor="userId" className="block text-sm font-semibold leading-6 text-gray-900">
                                아이디
                            </label>
                            <div className="mt-2.5">
                                <input
                                    type="text"
                                    name="userId"
                                    id="userId"
                                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600   focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.adminId && cond.adminId) || ""}
                                    onChange={(e) => {
                                        setCond((preValue) => {
                                            return {
                                                ...preValue,
                                                adminId: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="password" className="block text-sm font-semibold leading-6 text-gray-900">
                                비밀번호
                            </label>
                            <div className="mt-2.5">
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600   focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.adminPw && cond.adminPw) || ""}
                                    disabled
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userName" className="block text-sm font-semibold leading-6 text-gray-900">
                                이름
                            </label>
                            <div className="mt-2.5">
                                <input
                                    type="text"
                                    name="userName"
                                    id="userName"
                                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600   focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.adminNm && cond.adminNm) || ""}
                                    onChange={(e) => {
                                        setCond((preValue) => {
                                            return {
                                                ...preValue,
                                                adminNm: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="phoneNm" className="block text-sm font-semibold leading-6 text-gray-900">
                                휴대전화 번호
                            </label>
                            <div className="mt-2.5">
                                <input
                                    type="tel"
                                    name="phoneNm"
                                    id="phoneNm"
                                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600   focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.adminHpNo && cond.adminHpNo) || ""}
                                    onChange={(e) => {
                                        setCond((preValue) => {
                                            return {
                                                ...preValue,
                                                adminHpNo: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userMail" className="block text-sm font-semibold leading-6 text-gray-900">
                                이메일
                            </label>
                            <div className="mt-2.5">
                                <input
                                    type="email"
                                    name="userMail"
                                    id="userMail"
                                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600   focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.adminEmail && cond.adminEmail) || ""}
                                    onChange={(e) => {
                                        setCond((preValue) => {
                                            return {
                                                ...preValue,
                                                adminEmail: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="joinDate" className="block text-sm font-semibold leading-6 text-gray-900">
                                가입일자
                            </label>
                            <div className="mt-2.5">
                                <input
                                    type="date"
                                    name="joinDate"
                                    id="joinDate"
                                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600   focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.adminRegConvert && cond.adminRegConvert) || ""}
                                    disabled
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="phoneNm" className="block text-sm font-semibold leading-6 text-gray-900">
                                직급
                            </label>
                            <div className="mt-2">
                                <Listbox
                                    value={cond.adminLevelCd}
                                    onChange={(val) => {
                                        // console.log("e.value", val);
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                adminLevelCd: val.code,
                                                adminLevelNm: val.name,
                                                adminType: val.code !== '0001' ? '0001' : '',
                                            };
                                        });
                                        setSelectedAdminLevelCd(val);
                                    }}
                                >
                                    <div className="relative mt-2">
                                        <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-2 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6">
                                            <span className="block truncate">{selectedAdminLevelCd && selectedAdminLevelCd.name}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                            </span>
                                        </ListboxButton>

                                        <ListboxOptions
                                            transition
                                            className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                                        >
                                            {listAdminLevelCd &&
                                                listAdminLevelCd.map((level) => (
                                                    <ListboxOption
                                                        key={level.code}
                                                        className="group relative cursor-default font-medium select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-blue-600 data-[focus]:font-semibold data-[focus]:text-white"
                                                        value={level}
                                                    >
                                                        <span className="block truncate font-normal group-data-[selected]:font-semibold">
                                                            {level.name}
                                                        </span>
                                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                                                            <CheckIcon aria-hidden="true" className="h-5 w-5" />
                                                        </span>
                                                        {/* <span
                                                            className={classNames(
                                                                selected ? "font-semibold" : "font-normal",
                                                                "block truncate"
                                                            )}
                                                        >
                                                            {level.name}
                                                        </span>

                                                        {selected ? (
                                                            <span
                                                                className={classNames(
                                                                    active ? "text-white" : "text-blue-600",
                                                                    "absolute inset-y-0 right-0 flex items-center pr-4"
                                                                )}
                                                            >
                                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                            </span>
                                                        ) : null} */}
                                                    </ListboxOption>
                                                ))}
                                        </ListboxOptions>
                                    </div>
                                </Listbox>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userMail" className="block text-sm font-semibold leading-6 text-gray-900">
                                사용여부
                            </label>
                            <div className="mt-2">
                                <Listbox
                                    value={checked}
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                adminType: e.value,
                                            };
                                        });
                                        setChecked(
                                            checkOptions.find((opt) => opt.value === e.value) || checkOptions[0]
                                        );
                                    }}
                                >
                                    <div className="relative mt-2">
                                        <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-2 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6">
                                            <span className="block truncate">{checked.name}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                            </span>
                                        </ListboxButton>

                                        <ListboxOptions
                                            transition
                                            className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                                        >
                                            {checkOptions.map((person) => (
                                                <ListboxOption
                                                    key={person.id}
                                                    className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-blue-600 data-[focus]:font-bold data-[focus]:text-white"
                                                    value={person}
                                                >
                                                    <span className="block truncate font-normal group-data-[checked]:font-semibold">
                                                        {person.name}
                                                    </span>
                                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600 group-data-[focus]:text-white [.group:not([data-checked])_&]:hidden">
                                                        <CheckIcon aria-hidden="true" className="h-5 w-5" />
                                                    </span>
                                                    {/* <span
                                                        className={classNames(selected ? "font-semibold" : "font-normal", "block truncate")}
                                                    >
                                                        {person.name}
                                                    </span>

                                                    {selected ? (
                                                        <span
                                                            className={classNames(
                                                                active ? "text-white" : "text-blue-600",
                                                                "absolute inset-y-0 right-0 flex items-center pr-4"
                                                            )}
                                                        >
                                                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                        </span>
                                                    ) : null} */}
                                                </ListboxOption>
                                            ))}
                                        </ListboxOptions>
                                    </div>
                                </Listbox>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="addr" className="block text-sm font-semibold leading-6 text-gray-900">
                                사업장 주소
                            </label>
                            <div className="mt-2.5">
                                <input
                                    type="text"
                                    name="addr"
                                    id="addr"
                                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600   focus:ring-blue-600 sm:text-sm sm:leading-6 mb-2"
                                    value={(cond.adminAddr1 && cond.adminAddr1) || ""}
                                    onChange={(e) => {
                                        setCond((preValue) => {
                                            return {
                                                ...preValue,
                                                adminAddr1: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="addr" className="block text-sm font-semibold leading-6 text-gray-900">
                                　
                            </label>
                            <div className="mt-2.5">
                                <input
                                    type="text"
                                    name="detailAddr"
                                    id="detailAddr"
                                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600   focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.adminAddr2 && cond.adminAddr2) || ""}
                                    onChange={(e) => {
                                        setCond((preValue) => {
                                            return {
                                                ...preValue,
                                                adminAddr2: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-span-2">
                            <label className="block text-sm font-semibold leading-6 text-gray-900 mb-1">
                                회원구분(조직)
                            </label>
                            <div className="flex gap-2">
                                <div className="flex-1">
                                <SelectMenu
                                    options={orgTree}
                                    onSelect={(e) => {
                                        console.log("🚀 ~ AdminInfo ~ e:", e);
                                        setCond((preVal) => ({
                                            ...preVal,
                                            orgId: e.id,
                                        }));
                                    }}
                                    selectedId={cond.orgId?.toString() ?? null}
                                />
                                </div>
                                <button
                                    onClick={() => setShowOrgPopup(true)}
                                    className="rounded-md bg-gray-200 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300 whitespace-nowrap"
                                >
                                조회
                                </button>
                                {showOrgPopup && (
                                    <SearchOrgDialog
                                    onClose={() => setShowOrgPopup(false)}
                                    onSelect={(item) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                orgId: item.id,
                                            }
                                        });
                                    }}
                                    OrgTree={orgTree}
                                    />
                                )}
                            </div>
                        </div>

                    </div>
                    <div className="mt-10 flex justify-between">
                        <button
                            className="inline-flex items-center gap-x-1.5 rounded bg-red-500 px-3 py-2 text-sm font-semibold text-white hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400"
                            onClick={() => setShowResetPassDialog(true)}
                        >
                            <ArrowPathIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                            비밀번호 초기화
                        </button>
                        <div className="flex">
                            <div className="mr-3">
                                <button
                                    type="button"
                                    className="inline-flex items-center gap-x-1.5 rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                                    onClick={() => {
                                        updateAdminInfo();
                                    }}
                                >
                                    <CheckCircleIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                    수정
                                </button>
                            </div>
                            <div>
                                <button
                                    type="button"
                                    className="rounded-md bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-600 shadow-sm hover:bg-blue-100"
                                    onClick={() => window.history.back()}
                                >
                                    목록
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
